import { gql } from '@apollo/client';

export const PRODUCT_VARIANT_DATA = gql`
  query getProductVariantData($ids: [ID]!) {
    productVariants(ids: $ids) {
      id
      categories
      demographics {
        gender
      }
    }
  }
`;

export const PRODUCTCARD_UPSELL_FRAGMENT = gql`
  fragment ProductCardUpsellFragment on Product {
    id
    title
    featuredImage {
      file {
        url
      }
    }
    externalSystems {
      shopify
    }
    url
    variants {
      id
      price {
        basePrice
        discountPrice
        currency
      }
    }
    colors {
      id
      swatch {
        id
      }
    }
  }
`;

export default {};
